import { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import {
  fetchCheckout,
  fetchCountries,
  fetchCities,
  fetchTownships,
  fetchDistricts,
  setDeliveryOption,
  setAddress,
  setShippingOption,
  setSampleProduct,
  setPaymentOption,
  setRetailStore,
  setDeliveryOptionWithAddress,
  setInstallmentOption,
  sendAddressForm,
  checkoutWithCashRegister,
  askToCash,
  deleteAddressForm,
  addGiftBox,
  removeGiftBox,
  setNotes,
  setFundsTransferChoicePage,
  setPaymentFundTransfer,
} from "actions/checkout";
import { CASH_PAYMENT_TYPE, PAGES } from "constants/checkout";
import { isDefinedAndNotEmpty } from "utils";
import { objectSelector } from "theme/utils";
import { fetchCurrentStaff } from "actions/staffs";

const $R = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/routes`);
const $STA = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/staticTextMaps/app`);

let _content = null;

const Checkout = (props) => {
  const {
    fetchCheckout,
    fetchCountries,
    fetchCities,
    fetchTownships,
    fetchDistricts,
    setDeliveryOption,
    setAddress,
    setShippingOption,
    setSampleProduct,
    setPaymentOption,
    setRetailStore,
    setDeliveryOptionWithAddress,
    setInstallmentOption,
    sendAddressForm,
    checkoutWithCashRegister,
    askToCash,
    deleteAddressForm,
    checkout,
    fetchCurrentStaff,
    context: { number: orderNumber },
    preOrder,
    history,
    pending,
  } = props;

  const dispatch = useDispatch();

  const [tab, setTab] = useState(0);
  const [paymentType, setPaymentType] = useState(null);
  const [completed, setCompleted] = useState(false);
  const [tabChangable, setTabChangable] = useState(false);
  const [agreement, setAgreement] = useState(true);
  const [cardId, setCardId] = useState(undefined);
  const [installmentId, setInstallmentId] = useState("");
  const [giftBoxChecked, setGiftBoxChecked] = useState(false);

  useEffect(() => {
    if (!pending && !preOrder.user_email) {
      history.push($R.BASKET.path);
    }
  }, [preOrder.user_email, pending]);

  useEffect(() => {
    fetchCheckout();
    fetchCurrentStaff();
  }, []);

  useEffect(() => {
    const {
      context: { barcode, page_name },
    } = props;

    const checkOnSetCashPayment =
      paymentType === CASH_PAYMENT_TYPE &&
      page_name === PAGES.cashRegisterInstallmentSelectionPage &&
      !barcode &&
      !completed;

    if (checkOnSetCashPayment) {
      setCompleted(true);
      onSetCashPayment();
    }
  }, [paymentType, completed]);

  useEffect(() => {
    const paymentOptions = props.context.payment_options;

    if (
      isDefinedAndNotEmpty(paymentOptions) &&
      props.preOrder.shipping_option
    ) {
      if (!tabChangable) {
        setTabChangable(true);
      }
    } else {
      setTabChangable(false);
    }

    if (props.context.ask_to_cash) {
      let id = window.setTimeout(function () {}, 0);
      while (id--) {
        window.clearTimeout(id);
      }
      onAskToCash();
    }
  }, [props.context, props.preOrder]);

  const changeTab = (tab) => {
    if (tabChangable) {
      setTab(tab);
    }
  };

  const getPreOrder = (field) => {
    return props.preOrder[field];
  };

  const onSetAgreement = (checked) => {
    setAgreement(checked);
  };

  const onSetDeliveryOptionWithAddress = (
    address,
    billingAddress,
    deliveryOption
  ) => {
    setDeliveryOptionWithAddress(address, billingAddress, deliveryOption);
  };

  const onSetDeliveryOption = (deliveryOption) => {
    setDeliveryOption(deliveryOption);
  };

  const onSetAddress = (address, billingAddress) => {
    setAddress(address, billingAddress);
  };

  const onSetRetailStore = (storePk, billingAddress) => {
    setRetailStore(storePk, billingAddress);
  };

  const onSetShippingOption = (pk) => {
    setShippingOption(pk);
  };

  const onSetSampleProduct = () => {
    setSampleProduct();
  };

  const onSetPaymentOption = (pk) => {
    setPaymentOption(pk);
  };

  const onSelectInstallmentOption = (installmentId) => {
    setInstallmentId(installmentId);
  };

  const onSetInstallmentOption = (pk) => {
    setInstallmentOption(pk);
    onAskToCash();
  };

  const onSelectInstallmentId = (installmentId) => {
    setInstallmentId(installmentId);
  };

  const onSetCashPayment = () => {
    setInstallmentOption();
  };

  const onSetPaymentType = (paymentType) => {
    setPaymentType(paymentType);
    setCompleted(false);
    onGetBarcode();
  };

  const onFetchCountries = () => {
    fetchCountries();
  };

  const onFetchCities = (pk, name) => {
    fetchCities(pk, name);
  };

  const onFetchTownships = (pk) => {
    fetchTownships(pk);
  };

  const onFetchDistricts = (pk) => {
    fetchDistricts(pk);
  };

  const onSendAddress = (formData, pk) => {
    sendAddressForm(formData, pk);
  };

  const onDeleteAddress = (pk) => {
    deleteAddressForm(pk);
  };

  const onGetBarcode = () => {
    checkoutWithCashRegister(agreement);
  };

  const onAskToCash = () => {
    if ($STA.BRAND === "Samsung") {
      if (!!orderNumber) {
        setTimeout(() => {
          askToCash();
        }, 5000);
      } else {
        return;
      }
    } else {
      setTimeout(() => {
        askToCash();
      }, 5000);
    }
  };

  const handleCardSelection = (cardId) => {
    setCardId(cardId);
  };

  const handleChange = (e) => {
    setGiftBoxChecked(e.target.value);

    if (e.target.value) {
      addGiftBox(e.target.value);
    } else {
      removeGiftBox(e.target.value);
    }
  };

  const onSetNotes = (value) => {
    dispatch(setNotes(value));
  };

  const onSetFundsTransferChoicePage = (pk) => {
    dispatch(setFundsTransferChoicePage(pk));
  };

  const onSetPaymentFundTransfer = (agreement) => {
    dispatch(setPaymentFundTransfer(agreement));
  };

  const onSaveAndContinueButtonClick = () => {
    const paymentOptions = objectSelector(checkout, "context.payment_options");

    if (!paymentOptions.length) return;
    const payLaterObj = paymentOptions.find(
      (option) => option.payment_type === "pay_later"
    );
    const payLaterPk = objectSelector(payLaterObj, "pk");

    if (!payLaterPk) return;

    setPaymentOption(payLaterPk);

    changeTab(1);
  };

  return (
    _content &&
    _content({
      props,
      tab,
      paymentType,
      completed,
      tabChangable,
      agreement,
      cardId,
      installmentId,
      giftBoxChecked,
      changeTab,
      onSetAgreement,
      onSetDeliveryOptionWithAddress,
      onSetDeliveryOption,
      onSetAddress,
      onSetRetailStore,
      onSetShippingOption,
      onSetSampleProduct,
      onSetPaymentOption,
      onSelectInstallmentOption,
      onSetInstallmentOption,
      onSelectInstallmentId,
      onSetPaymentType,
      onFetchCountries,
      onFetchCities,
      onFetchTownships,
      onFetchDistricts,
      onSendAddress,
      onDeleteAddress,
      getPreOrder,
      handleCardSelection,
      handleChange,
      onSetNotes,
      onSetFundsTransferChoicePage,
      onSetPaymentFundTransfer,
      onSaveAndContinueButtonClick,
    })
  );
};

const mapDispatchToProps = {
  fetchCheckout,
  fetchCountries,
  fetchCities,
  fetchTownships,
  fetchDistricts,
  setDeliveryOption,
  setAddress,
  setShippingOption,
  setSampleProduct,
  setPaymentOption,
  setRetailStore,
  setDeliveryOptionWithAddress,
  setInstallmentOption,
  sendAddressForm,
  checkoutWithCashRegister,
  askToCash,
  deleteAddressForm,
  fetchCurrentStaff,
};

const mapStateToProps = (state) => ({
  pending: state.checkout.pending,
  modalPending: state.checkout.modalPending,
  preOrder: state.checkout.preOrder,
  context: state.checkout.context,
  customer: state.customerDetail.customer,
  error: state.checkout.error,
  qrUrl: state.checkout.qrUrl,
  orderStatusUrl: state.checkout.orderStatusUrl,
  checkout: state.checkout,
});

export default function (content) {
  _content = content;
  return connect(mapStateToProps, mapDispatchToProps)(Checkout);
}



// WEBPACK FOOTER //
// ./src/_pageContainers/checkout/checkout/index.js